import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a date string for display in the UI.
 */
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '—'
  const d = new Date(dateStr)
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

/**
 * Format a date relative to now (e.g. "2 часа назад").
 */
export function formatRelativeTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '—'
  const d = new Date(dateStr)
  const now = new Date()
  const diffMs = now.getTime() - d.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins < 1) return 'только что'
  if (diffMins < 60) return `${diffMins} мин. назад`
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours} ч. назад`
  const diffDays = Math.floor(diffHours / 24)
  return `${diffDays} д. назад`
}

/**
 * Returns urgency class based on how long ago a lead was created (unclaimed).
 * Red = > 30 min, Yellow = > 10 min, else null.
 */
export function getLeadUrgencyClass(createdAt: string, claimedBy: string | null): string | null {
  if (claimedBy) return null
  const diffMins = (Date.now() - new Date(createdAt).getTime()) / 60000
  if (diffMins > 30) return 'urgency-red'
  if (diffMins > 10) return 'urgency-yellow'
  return null
}

/**
 * Format price in RUB.
 */
export function formatRub(amount: number | null | undefined): string {
  if (amount == null) return '—'
  return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumFractionDigits: 0 }).format(amount)
}
